import { LeftSnipeSidePanel } from './LeftSidePanel';
import React from 'react';

export function TerminalPage({ children }: { children: React.ReactNode }) {
  return (
    <div className="space-y-0 pb-16 lg:pb-0 lg:space-y-1">
      <div className="xxs:gap-1 xxs:py-1 lg:grid lg:grid-cols-6">
        <div className="xxs:hidden lg:block lg:sticky lg:top-0 lg:overflow-y-auto lg:h-terminal">
          <LeftSnipeSidePanel />
        </div>
        <div className="flex flex-col xxs:gap-3 overflow-hidden w-full col-span-5">
          {children}
        </div>
      </div>
    </div>
  );
}
